module.exports = "<div id=datetimepicker> <input fb-date-time-picker type=text fb-date-formatter ng-model=vm.value fb-max-date=\"{{vm.maxDate}}\" fb-min-date=\"{{vm.minDate}}\" id=dpicker name=dpicker placeholder=DD/MM/YYYY ng-change=vm.valueChanged(vm.value) class=\"input input-date\"/> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/common/date-picker.html
// module id = 580
// module chunks = 0